<template>
  <div class="table-cell-chips">
    <v-chip
      v-for="(item, idx) in visibleItems"
      :key="idx"
      v-bind="chipProps"
      class="mr-1 mb-1"
    >
      <slot name="chip" :item="item">
        {{ getItemText(item) }}
      </slot>
    </v-chip>
    <v-chip
      v-if="hasOverflow"
      v-bind="overflowChipProps"
      class="overflow-chip"
      @click="$emit('show-all', items)"
    >
      +{{ items.length - maxVisible }}
    </v-chip>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import type { TableCellChipsProps } from './types'

export default Vue.extend<any, any, any, TableCellChipsProps>({
  name: 'TableCellChips',
  props: {
    items: {
      type: Array,
      required: true
    },
    maxVisible: {
      type: Number,
      default: 3
    },
    itemText: {
      type: [String, Function],
      default: null
    },
    chipProps: {
      type: Object,
      default: () => ({
        xSmall: true,
        outlined: true
      })
    }
  },
  computed: {
    visibleItems(): any[] {
      return this.items.slice(0, this.maxVisible)
    },
    hasOverflow(): boolean {
      return this.items.length > this.maxVisible
    },
    overflowChipProps(): Record<string, any> {
      return {
        xSmall: true
      }
    }
  },
  methods: {
    getItemText(item: any): string {
      if (!this.itemText) return item
      if (typeof this.itemText === 'function') return this.itemText(item)
      return item[this.itemText]
    }
  }
})
</script>

<style scoped>
.table-cell-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
}

/* Override Vuetify's v-chip colour for overflow chip with design token for dark mode support */
.overflow-chip {
  background-color: var(--muted) !important;
  color: var(--muted-foreground) !important;
  cursor: pointer;
}

.overflow-chip:hover {
  background-color: var(--secondary) !important;
}
</style>
